import { retext } from 'retext';
import { visit } from 'unist-util-visit';
import smartypants from 'retext-smartypants';

/**
 * Remark plugin to add SmartyPants.
 *
 * Based on https://github.com/silvenon/remark-smartypants/blob/master/index.js.
 *
 * @param {object} options
 */
export default function remarkSmartypants(options) {
  const processor = retext().use(smartypants, options);
  const transformer = tree => {
    visit(tree, 'text', node => {
      node.value = String(processor.processSync(node.value));
    });
  };
  return transformer;
}
